var map = {
	"./elephant_ui_disappointed": 980,
	"./elephant_ui_disappointed.svg": 980,
	"./elephant_ui_working": 981,
	"./elephant_ui_working.svg": 981,
	"./glitch-preview": 1061,
	"./glitch-preview.jpg": 1061,
	"./logo_warn_glitch": 573,
	"./logo_warn_glitch.svg": 573,
	"./mbstobon-ui-0": 1062,
	"./mbstobon-ui-0.png": 1062,
	"./mbstobon-ui-1": 1063,
	"./mbstobon-ui-1.png": 1063,
	"./mbstobon-ui-2": 1064,
	"./mbstobon-ui-2.png": 1064,
	"./mbstobon-ui-3": 1065,
	"./mbstobon-ui-3.png": 1065,
	"./wave-drawer": 1066,
	"./wave-drawer-glitched": 1067,
	"./wave-drawer-glitched.png": 1067,
	"./wave-drawer.png": 1066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1249;